module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "7%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("My name is William Deep, Jr. I’m from Baltimore, Maryland, and I live for adventure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The people who think I’m a normal twelve-year-old call me Billy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the few who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" know me call me by my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("secret")]), _vm._v(" name — the Undersea Mutant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For me, danger is like breakfast. I can’t start my day without a healthy, balanced bowl of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("danger")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Here I am in the middle of the ocean. Sure, it’s dark and dangerous. But what do I call it?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m swimming off the island of Careebo, a tiny sand field in the Caribbean Sea. I peer straight ahead through my infrared snorkel mask. My laser-guided razor fins cut through the waves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I follow a school of silvery angelfish, sparkling like diamonds in the sunlit waters. They don’t seem to realize the danger nearby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But my mutant senses are alert. No underwater villain can escape me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You may remember some of my adventures.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m the one who defeated Sandy the Squid. He called himself the Cephalopod of Steel. Sandy liked to tickle swimmers to death — until I tied his tentacles in a knot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Remember the Ragin’ Ray of Honolulu Bay? He’s not ragin’ anymore. How about Joe, the Great White Stingray? After a smackdown with the Undersea Mutant, he floundered off with his stinger between his fins!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Snapping Tortoise of Terror? After our three-day underwater battle, I tossed him into a soup bowl. His new name was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delicious")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yeah, I’m tough. But these are tough waters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And now I’m about to face my most dangerous foe. The Albino Electric Eel. The only one in the known universe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I see him waiting for me behind a bank of red and yellow coral. To "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" eyes, he’s just a long string of seaweed. That’s because you don’t have Mutant Vision.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I lower my 4-D hi-def mask into the water and kick harder. I glide toward my foe. I don’t hesitate. I grab him bare-handed and begin to apply my famous Eel Squeeze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZZZZZZZZZZZZT!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two hundred thousand volts of electricity shoot through my body. Enough power to electrocute a dozen men. But to me, it’s only a slight itch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I thrash and kick, wrestling with this Eel of Evil. Another jolt of electricity makes the churning water start to boil.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, it’s getting hot down here. But the only one who’s in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("real")]), _vm._v(" hot water is my wriggling enemy!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I hear a voice … a distant voice, calling my human name. “Billy? Billy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A desperate cry for help. Someone is in danger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I let go of the eel. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Catch you later!")]), _vm._v(" I think. I fight my way to the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Someone needs me!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f384d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545840330_ch001.vue
// module id = 72
// module chunks = 0